import isImpersonatingUser from 'src/utils/isImpersonatingUser'

export default function isImpersonatingOrganizationOnly(userData) {
    return userData.isImpersonating && !isImpersonatingUser(userData)
}
